import { component } from 'picoapp';

export default component(async (node) => {
  const { videoMode, opacity } = node.dataset;
  const playButton = node.querySelector<HTMLButtonElement>('[data-play]');
  const overlay = node.querySelector<HTMLDivElement>('[data-overlay]');
  const textContent = node.querySelector<HTMLDivElement>('[data-text-content]');
  const video = node.querySelector<HTMLVideoElement>('video');

  async function toggleVideoState(shouldPlay: boolean) {
    if (shouldPlay) {
      try {
        await video.play();
        video.muted = false;
      } catch (err) {
        console.error('Failed to play the video:', err);
      }
    } else {
      video.pause();
      video.muted = true;
    }
  }

  // Autoplay the video when the page loads
  async function playVideo() {
    try {
      await video.play();
    } catch (err) {
      console.error('Failed to play the video:', err);
    }
  }

  function toggleClasses(shouldDisplay: boolean) {
    if (shouldDisplay) {
      playButton.style.opacity = '1';
      playButton.style.visibility = 'visible';
      overlay.style.opacity = opacity;
      textContent.classList.remove('fadeOutDown');
      textContent.classList.add('fadeUpIn');
    } else {
      playButton.style.opacity = '0';
      playButton.style.visibility = 'hidden';
      overlay.style.opacity = '0';
      textContent.classList.remove('fadeUpIn');
      textContent.classList.add('fadeOutDown');
    }
  }

  if (videoMode === 'manual') {
    playButton.addEventListener('click', (event) => {
      event.stopPropagation();
      playButton.ariaPressed = 'true';
      toggleClasses(false);
      toggleVideoState(true);
    });

    node.addEventListener('click', (event) => {
      if (playButton.getAttribute('aria-pressed') === 'false') {
        event.stopPropagation();
        playButton.ariaPressed = 'true';
        toggleClasses(false);
        toggleVideoState(true);
      } else {
        event.stopPropagation();
        playButton.ariaPressed = 'false';
        toggleClasses(true);
        toggleVideoState(false);
      }
    });
  }

  if (videoMode === 'autoplay') {
    let isFirstPlayButtonClick = true;

    playButton.addEventListener('click', (event) => {
      event.stopPropagation();
      playButton.ariaPressed = 'true';
      if (isFirstPlayButtonClick) {
        isFirstPlayButtonClick = false;
        video.currentTime = 0;
      }
      toggleClasses(false);
      toggleVideoState(true);
    });

    node.addEventListener('click', (event) => {
      if (playButton.getAttribute('aria-pressed') === 'false') {
        event.stopPropagation();
        playButton.ariaPressed = 'true';
        if (isFirstPlayButtonClick) {
          isFirstPlayButtonClick = false;
          video.currentTime = 0;
        }
        toggleClasses(false);
        toggleVideoState(true);
      } else {
        event.stopPropagation();
        playButton.ariaPressed = 'false';
        toggleClasses(true);
        toggleVideoState(false);
      }
    });

    // Call the function
    playVideo();
  }
});
